import { ChartMark, WidgetKind, type Report } from 'corso-admin-ui';

export const overview = {
  key: 'overview',
  label: 'Overview',
  dataset: 'supportConversations',
  timeFields: ['startedOn'],
  widgets: [
    { kind: WidgetKind.kpi, metric: 'conversations' },
    {
      kind: WidgetKind.kpi,
      metric: 'avgFirstResponseMinutes',
      description: 'By the day of the first response',
      timeField: 'firstRespondedOn',
    },
    {
      kind: WidgetKind.kpi,
      metric: 'messagesSent',
      dataset: 'supportMessages',
      timeField: 'sentOn',
    },
    {
      kind: WidgetKind.kpi,
      metric: 'messagesReceived',
      dataset: 'supportMessages',
      timeField: 'sentOn',
    },
    {
      kind: WidgetKind.kpi,
      metric: 'csatScore',
      dataset: 'supportCsat',
      timeField: 'ratedOn',
    },
    {
      kind: WidgetKind.kpi,
      metric: 'scoresCollected',
      dataset: 'supportCsat',
      timeField: 'ratedOn',
    },
    {
      kind: WidgetKind.overTime,
      title: 'New conversations over time',
      mark: ChartMark.line,
      metrics: ['conversations'],
    },
    {
      kind: WidgetKind.overTime,
      title: 'Messages over time',
      mark: ChartMark.line,
      metrics: ['messagesSent', 'messagesReceived'],
      dataset: 'supportMessages',
      timeField: 'sentOn',
    },
    {
      kind: WidgetKind.overTime,
      title: 'CSAT score over time',
      mark: ChartMark.line,
      metrics: ['csatScore'],
      dataset: 'supportCsat',
      timeField: 'ratedOn',
    },
    {
      kind: WidgetKind.table,
      title: 'Messages by sender',
      dimensions: ['sentBy'],
      metrics: ['messagesSent', 'messagesReceived'],
      dataset: 'supportMessages',
      timeField: 'sentOn',
    },
  ],
} as const satisfies Report;
